import { render } from "./indexReadjustmentComponent.vue?vue&type=template&id=23e83c82"
import script from "./indexReadjustmentComponent.vue?vue&type=script&lang=js"
export * from "./indexReadjustmentComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__